/** Shape of the GET /copilot-conversation API response */
export interface CopilotConversationResponse {
  copilot_conversation_id?: string | null;
  last_activity_at?: string | null;
}

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Extracts the conversation ID from a copilot-conversation API response,
 * returning it only if it exists and is no older than one day.
 * Returns null if the ID is absent, not a string, or has expired.
 */
export function resolveStoredConversationId(
  data: CopilotConversationResponse,
): string | null {
  const id =
    typeof data.copilot_conversation_id === "string"
      ? data.copilot_conversation_id
      : null;
  if (!id) return null;

  const lastActivity = data.last_activity_at
    ? new Date(data.last_activity_at)
    : null;

  if (!lastActivity || Date.now() - lastActivity.getTime() > ONE_DAY_MS) {
    return null;
  }

  return id;
}
